/* Strange Little Press | theme.js
   No dependencies. Small, a little feral. */
(function () {
  'use strict';
  var doc = document;

  /* ---- Rotating announcement bar ---- */
  var msgs = doc.querySelectorAll('[data-announce-msg]');
  if (msgs.length > 1 && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    var mi = 0;
    window.setInterval(function () {
      msgs[mi].hidden = true;
      mi = (mi + 1) % msgs.length;
      msgs[mi].hidden = false;
    }, 5000);
  }

  /* ---- Mobile navigation ---- */
  var toggle = doc.querySelector('[data-nav-toggle]');
  var nav = doc.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }

  /* ---- Reveal on scroll ---- */
  var reveals = doc.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---- Quantity steppers ---- */
  doc.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-step'), 10);
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- Collection filters: submit as soon as something changes ---- */
  doc.querySelectorAll('[data-autosubmit]').forEach(function (form) {
    form.addEventListener('change', function () { form.submit(); });
  });

  /* ---- Product page ---- */
  doc.querySelectorAll('[data-product-section]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variant-data]');
    var variants = [];
    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (err) { variants = []; }

    var idInput = root.querySelector('[data-variant-id]');
    var priceNow = root.querySelector('[data-price-now]');
    var priceWas = root.querySelector('[data-price-was]');
    var addBtn = root.querySelector('[data-add-btn]');
    var addLabel = root.querySelector('[data-add-label]');
    var slides = root.querySelectorAll('[data-slide]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    var groups = root.querySelectorAll('[data-option-group]');

    function showSlide(id) {
      var found = false;
      slides.forEach(function (s) { if (s.getAttribute('data-slide') === String(id)) found = true; });
      if (!found) return;
      slides.forEach(function (s) { s.hidden = s.getAttribute('data-slide') !== String(id); });
      thumbs.forEach(function (t) {
        t.setAttribute('aria-current', t.getAttribute('data-thumb') === String(id) ? 'true' : 'false');
      });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showSlide(t.getAttribute('data-thumb')); });
    });

    function selectedOptions() {
      return Array.prototype.map.call(groups, function (g) {
        var checked = g.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function update() {
      var sel = selectedOptions();
      var match = null;
      variants.forEach(function (v) {
        var ok = v.options.every(function (o, i) { return o === sel[i]; });
        if (ok) match = v;
      });
      if (!match) {
        if (addBtn) { addBtn.disabled = true; }
        if (addLabel) { addLabel.textContent = addBtn.getAttribute('data-unavailable'); }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceNow) priceNow.textContent = match.price;
      if (priceWas) {
        priceWas.textContent = match.compare || '';
        priceWas.hidden = !match.compare;
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        if (addLabel) {
          addLabel.textContent = match.available ? addBtn.getAttribute('data-add') : addBtn.getAttribute('data-sold');
        }
      }
      if (match.image) showSlide(match.image);
      var stockEl = root.querySelector('[data-stock]');
      if (stockEl) {
        if (match.stock !== null && match.stock > 0) {
          stockEl.textContent = match.stock + ' available';
          stockEl.hidden = false;
        } else {
          stockEl.hidden = true;
        }
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      } catch (err) { /* old browser, no harm done */ }
    }

    groups.forEach(function (g) { g.addEventListener('change', update); });
  });
})();
